<template>
  <div class="container">
    <h2 class="profile-page-title">{{ $t('students') }}</h2>
    <div class="row">
      <div
        class="col-sm-4"
        :key="child.id"
        v-for="child in children"
      >
        <ChildCard
          :child="child"
          @update="updateChild(child)"
          @delete="deleteChild(child)"
        />
      </div>

      <div class="col-sm-4">
        <div class="child-card">
          <div class="child-card__content">
            <div class="child-card__avatar">
              <img class="img-fluid" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAHgBAMAAACP+qOmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAwUExURdfg5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP2rzZMAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACHSURBVHja7cExAQAAAMKg9U9tCj8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKsaw+8AAeScSvcAAAAASUVORK5CYII=">
            </div>

            <div class="child-card__age">
              <a
                class="child-card__edit"
                href="javascript:;"
                @click="edit=!edit"
              >
                {{ $t('add') }}
              </a>
            </div>
          </div><!-- /.child-card__content -->

          <form
            class="child-card-form"
            v-if="edit"
            @submit.prevent="createChild"
          >
            <div class="form-group">
              <input
                required
                type="text"
                class="form-control"
                :placeholder="$t('student_name')"
                v-model="name"
              >
            </div>

            <div class="form-group">
              <base-date-picker
                required
                :placeholder="$t('birthday')"
                format="DD.MM.YYYY"
                v-model="formattedBirthday"
              />
            </div>

            <div class="row align-items-center">
              <div class="col-6">
                <button type="submit" class="btn btn-success">{{ $t('save') }}</button>
              </div>
              <div class="col-6 text-right">
                <a
                  class="child-card__edit"
                  href="javascript:;"
                  @click="edit=!edit"
                >
                  {{ $t('cancel') }}
                </a>
              </div>
            </div>
          </form>
        </div><!-- /.child-card -->
      </div>
    </div><!-- /.row -->
  </div>
</template>

<script>
import moment from 'moment';
import childApi from '@/data/ChildApi';
import ChildCard from './ChildCard';

export default {
  name: 'Browse',

  data() {
    return {
      error: null,
      edit: false,
      children: [],

      // new child
      name: null,
      birthday: null,
    }
  },

  created() {
    this.fetchChildren();
  },

  computed: {
    formattedBirthday: {
      get() {
        return moment(this.birthday, 'YYYY-MM-DD').toDate();
      },
      set(value) {
        this.birthday = moment(value).format('YYYY-MM-DD');
      }
    }
  },

  methods: {
    fetchChildren() {
      childApi.fetchChildes()
        .then(response => {
          this.children = response;
        });
    },

    check() {
      return (this.name && /^\d{4}-\d{2}-\d{2}$/.test(this.birthday));
    },

    createChild() {
      if (!this.check()) {
        return false;
      }
      childApi.createChild({ name: this.name, birth: this.birthday })
        .then(response => {
          this.children.push(response);
          this.name = this.birthday = null;
          this.edit = false;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.error = this.$t('error_401');
          } else {
            this.error = error.response.data;
          }
        });
    },

    updateChild(child) {
      childApi.updateChild(child)
        .catch(error => {
          if (error.response.status === 401) {
            this.error = this.$t('error_401');
          } else {
            this.error = error.response.data;
          }
        });
    },

    deleteChild(child) {
      childApi.deleteChild(child.id)
        .then(() => {
          this.children = this.children.filter(item => item.id !== child.id);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.error = this.$t('error_401');
          } else {
            this.error = error.response.data;
          }
        });
    }
  },

  components: {
    ChildCard,
  }
}
</script>

<style>
.child-card {
  border: 1px solid #d7e0e5;
  margin-bottom: 30px;
  position: relative;
}
.child-card__content {
  padding: 20px 20px 10px;
  text-align: center;
}
.child-card__avatar {
  margin-bottom: 20px;
}
.child-card__title {
  color: #f15c22;
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  margin-bottom: 0;
}
.child-card__age {
  color: #c0c0c0;
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  font-size: 1.15rem;
  margin-bottom: 40px;
}
.child-card__actions {
  position: relative;
}
.child-card__edit,
.child-card__delete {
  color: #c0c0c0 !important;
  text-decoration: underline;
}
.child-card__delete {
  position: absolute;
  right: 0;
  top: 0;
}
.child-card-form {
  background-color: #E8F2F4;
  padding: 20px;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
